import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { useFormInput } from '../../../utils/gatsby-helpers';
import { logoutUser, useAuthStatus } from '../../../services/google-oauth';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import Cookies from 'js-cookie';
import { StaticImage } from 'gatsby-plugin-image';

const ModalLogin = ({ state, plan, lang, selectedPlan }) => {
	const { executeRecaptcha } = useGoogleReCaptcha();

	const { authed, userAuthed } = useAuthStatus();

	const name = useFormInput('');
	const surname = useFormInput('');
	const email = useFormInput('');
	const locale = useFormInput(lang);
	const password = useFormInput('');
	const repassword = useFormInput('');

	const [isFormAvailable, setIsFormAvailable] = useState(true);
	const [loginError, setLoginError] = useState(null);
	const [showEmailForm, setShowEmailForm] = useState(false);
	const [showLoginForm, setShowLoginForm] = useState(false);
	const [signUpError, setSignUpError] = useState(null);
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	const changePasswordView = () => {
		setShowPassword(!showPassword);
	};

	const changeConfirmPasswordView = () => {
		setShowConfirmPassword(!showConfirmPassword);
	};

	// const [selectedPlan, setSelectedPlan] = useState(null)

	const loginElements = {
		p: ({ node, ...props }) => <p className="text--center" {...props} />,
		a: ({ node, ...props }) => (
			<a
				role='button'
				rel='nofollow'
				onClick={(e) => {
					e.preventDefault();
					if (!isFormAvailable) return;
					cleanForm();
					setShowLoginForm(true);
					setShowEmailForm(false);
				}}
			>
				{props.children}
			</a>
		),
	};

	const orLoginWithElements = {
		p: ({ node, ...props }) => <span {...props} />,
	};

	const signupElements = {
		p: ({ node, ...props }) => <p className="text--center" {...props} />,
		a: ({ node, ...props }) => (
			<a
				role='button'
				rel='nofollow'
				onClick={(e) => {
					e.preventDefault();
					if (!isFormAvailable) return;
					cleanForm();
					setShowLoginForm(false);
				}}
			>
				{props.children}
			</a>
		),
	};

	const closeModalForm = () => {
		if (!isFormAvailable) {
			return true;
		}

		const isBrowser = typeof window !== 'undefined';
		if (isBrowser === true) {
			if (window.location.href.includes('#pop-up')) {
				window.location.href = window.location.href.substr(0, window.location.href.indexOf('#'));
			}
		}

		// setShowModalPlanFree(false)
		state.closeMenu();
		// setShowModalPlanStarter(false)
		setShowEmailForm(false);
		setShowLoginForm(false);
		cleanForm();
		logoutUser();
	};

	const cleanForm = () => {
		name.onChange('');
		surname.onChange('');
		email.onChange('');
		password.onChange('');
		repassword.onChange('');
		setSignUpError(null);
	};

	const loginWihGoogle = async () => {
		if (!executeRecaptcha) {
			setLoginError('Execute Recaptcha fail');
			console.error('executeRecaptcha fail');
			return;
		}

		setIsFormAvailable(false);

		const cookieHubspotutk = Cookies.get('hubspotutk');
		const token = await executeRecaptcha('homepage');
		const json = {
			email: userAuthed.email,
			'google-id': userAuthed.id,
			//"g-recaptcha-response": token,
			'g-recaptcha-response': 'skipr1884',
			hubspotutk: cookieHubspotutk,
		};
		const data = JSON.stringify(json);
		const response = await fetch(process.env.ACCOUNT_LOGIN_URL, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: data,
		});
		const dataResponse = await response.json();

		if (response.ok && dataResponse.url) {
			logoutUser();
			window.location.href = dataResponse.url;
			return;
		}

		setIsFormAvailable(true);
		setLoginError(dataResponse.msg);
	};

	const handleAccountGoogleLoginRedirect = (e) => {
		e.preventDefault();
		const cookieHubspotutk = Cookies.get('hubspotutk');
		window.location.href = `${process.env.ACCOUNT_GOOGLE_LOGIN_URL}?pack=${selectedPlan}&hubspotutk=${cookieHubspotutk}&locale=${locale.value}`;
	};

	const handleLoginSubmit = async (e) => {
		e.preventDefault();

		setLoginError(null);

		if (password.value.length < 8) {
			setLoginError('La contraseña debe tener al menos 8 caracteres.');
			return;
		}

		if (!executeRecaptcha) {
			setLoginError('Execute Recaptcha fail');
			console.error('executeRecaptcha fail');
			return;
		}

		setIsFormAvailable(false);

		const cookieHubspotutk = Cookies.get('hubspotutk');
		const token = await executeRecaptcha('homepage');
		const json = {
			email: email.value,
			p: password.value,
			'g-recaptcha-response': token,
			//"g-recaptcha-response": "skipr1884"
			hubspotutk: cookieHubspotutk,
		};
		const data = JSON.stringify(json);
		const response = await fetch(process.env.ACCOUNT_LOGIN_URL, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: data,
		});
		const dataResponse = await response.json();

		console.log(response, dataResponse);

		if (response.ok && dataResponse.url) {
			window.location.href = dataResponse.url;
			return;
		}

		setIsFormAvailable(true);
		setLoginError(dataResponse.msg);
	};

	const handleSignUpSubmit = async (e) => {
		e.preventDefault();

		setSignUpError(null);

		if (!executeRecaptcha) {
			setSignUpError('Execute Recaptcha fail');
			console.error('executeRecaptcha fail');
			return;
		}

		if (password.value.length < 8) {
			setSignUpError('La contraseña debe tener al menos 8 caracteres.');
			return;
		}

		if (password.value !== repassword.value) {
			setSignUpError('Las contraseñas no coinciden.');
			return;
		}

		setIsFormAvailable(false);

		const cookieHubspotutk = Cookies.get('hubspotutk');
		const token = await executeRecaptcha('homepage');
		const json = {
			name: `${name.value} ${surname.value}`,
			email: email.value,
			p: password.value,
			locale: locale.value,
			'g-recaptcha-response': token,
			//"g-recaptcha-response": "skipr1884",
			pack: selectedPlan,
			hubspotutk: cookieHubspotutk,
		};
		const data = JSON.stringify(json);
		const response = await fetch(process.env.ACCOUNT_SIGN_UP_URL, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: data,
		});
		const dataResponse = await response.json();

		if (response.ok && dataResponse.url) {
			window.location.href = dataResponse.url;
			return;
		}

		setIsFormAvailable(true);
		setSignUpError(dataResponse.msg);
	};

	useEffect(() => {
		if (authed && userAuthed) {
			if (showLoginForm) {
				loginWihGoogle();
			} /* else if(selectedPlan) {
                signUpWithGoogle()
            }*/
		}
	}, [authed, userAuthed]);

	return (
		<Modal
			centered
			footer={null}
			maskClosable={false}
			onCancel={closeModalForm}
			title={
				<>
					<h4>{showLoginForm ? plan.title_login : plan.title}</h4>
					<ReactMarkdown
						children={showLoginForm ? plan.description_login : plan.description}
						rehypePlugins={[rehypeRaw]}
					/>
				</>
			}
			visible={state.isOpen}
			width={'100%'}
			wrapClassName="main__section"
			destroyOnClose={true}
		>
			<div className="ant-modal-body__thin">
				<div className="button-collapse-group">
					<button
						className="button-collapse"
						onClick={handleAccountGoogleLoginRedirect}
						disabled={!isFormAvailable}
					>
						<div className="button-collapse__header">
							<StaticImage src="../images/ic_google.png" alt="Google" width={16} height={16} />
							{plan.button_google}
						</div>
					</button>

					{showLoginForm && (
						<div className="divider divider--text">
							<ReactMarkdown
								children={plan.or_sign_up}
								rehypePlugins={[rehypeRaw]}
								components={orLoginWithElements}
							/>
						</div>
					)}

					{!showLoginForm && (
						<form
							className={`button-collapse ${showEmailForm ? 'button-collapse--expanded' : ''}`}
							onClick={() => setShowEmailForm(true)}
							onSubmit={handleSignUpSubmit}
						>
							<div className="button-collapse__header">
								<i className="icon-mail"></i>
								{plan.button_email}
							</div>

							{showEmailForm && (
								<div className="button-collapse__body">
									<input
										className="input"
										type="text"
										required
										placeholder={plan.form_name}
										disabled={!isFormAvailable}
										{...name}
									/>
									<input
										className="input"
										type="text"
										required
										placeholder={plan.form_lastname}
										disabled={!isFormAvailable}
										{...surname}
									/>
									<input
										className="input"
										type="email"
										required
										placeholder={plan.form_email}
										disabled={!isFormAvailable}
										{...email}
									/>
									<div className="input-button">
										<input
											className="input"
											type={!showPassword ? 'password' : 'text'}
											required
											placeholder={plan.form_password}
											disabled={!isFormAvailable}
											{...password}
										/>
										<button className="button-icon button-icon--sm" onClick={changePasswordView}>
											{!showPassword ? (
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M2.57441 12.7075C2.39492 12.4296 2.25003 12.1889 2.14074 12C2.25003 11.8111 2.39492 11.5704 2.57441 11.2925C3.03543 10.5787 3.71817 9.6294 4.60454 8.68394C6.39552 6.77356 8.89951 5 12 5C15.1005 5 17.6045 6.77356 19.3955 8.68394C20.2818 9.6294 20.9646 10.5787 21.4256 11.2925C21.6051 11.5704 21.75 11.8111 21.8593 12C21.75 12.1889 21.6051 12.4296 21.4256 12.7075C20.9646 13.4213 20.2818 14.3706 19.3955 15.3161C17.6045 17.2264 15.1005 19 12 19C8.89951 19 6.39552 17.2264 4.60454 15.3161C3.71817 14.3706 3.03543 13.4213 2.57441 12.7075ZM23 12C23.8944 11.5528 23.8943 11.5524 23.8941 11.5521L23 12ZM23.8941 11.5521C24.0348 11.8336 24.0352 12.1657 23.8944 12.4472L23 12C23.8944 12.4472 23.8938 12.4484 23.8936 12.4488L23.8925 12.4511L23.889 12.458L23.8777 12.4802C23.8681 12.4987 23.8546 12.5247 23.8372 12.5576C23.8025 12.6233 23.752 12.7168 23.686 12.834C23.5542 13.0684 23.3601 13.3985 23.1057 13.7925C22.5979 14.5787 21.8432 15.6294 20.8545 16.6839C18.8955 18.7736 15.8995 21 12 21C8.10049 21 5.10448 18.7736 3.14546 16.6839C2.15683 15.6294 1.40207 14.5787 0.894336 13.7925C0.63985 13.3985 0.445792 13.0684 0.313971 12.834C0.248023 12.7168 0.19754 12.6233 0.162753 12.5576C0.145357 12.5247 0.131875 12.4987 0.122338 12.4802L0.11099 12.458L0.107539 12.4511L0.105573 12.4472L0.999491 12.0003C0.111724 12.4441 0.105434 12.4468 0.105569 12.4472L0.105573 12.4472C-0.0351909 12.1657 -0.0351909 11.8343 0.105573 11.5528L1 12C0.105573 11.5528 0.106186 11.5516 0.10637 11.5512L0.107539 11.5489L0.11099 11.542L0.122338 11.5198C0.131875 11.5013 0.145357 11.4753 0.162753 11.4424C0.19754 11.3767 0.248023 11.2832 0.313971 11.166C0.445792 10.9316 0.63985 10.6015 0.894336 10.2075C1.40207 9.42131 2.15683 8.3706 3.14546 7.31606C5.10448 5.22644 8.10049 3 12 3C15.8995 3 18.8955 5.22644 20.8545 7.31606C21.8432 8.3706 22.5979 9.42131 23.1057 10.2075C23.3601 10.6015 23.5542 10.9316 23.686 11.166C23.752 11.2832 23.8025 11.3767 23.8372 11.4424C23.8546 11.4753 23.8681 11.5013 23.8777 11.5198L23.889 11.542L23.8925 11.5489L23.8941 11.5521ZM10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z"
														fill="#96939E"
													/>
												</svg>
											) : (
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<g clip-path="url(#clip0_960_16511)">
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L4.56849 5.9827C2.7597 7.53968 1.25036 9.41852 0.118844 11.5272C-0.0347895 11.8135 -0.0397387 12.1566 0.105573 12.4472L1 12C0.105573 12.4472 0.10637 12.4488 0.10637 12.4488L0.107539 12.4512L0.11099 12.458L0.122338 12.4802C0.131875 12.4988 0.145357 12.5247 0.162754 12.5576C0.19754 12.6233 0.248023 12.7168 0.313971 12.834C0.445792 13.0684 0.63985 13.3985 0.894336 13.7926C1.40207 14.5787 2.15683 15.6294 3.14546 16.684C5.10448 18.7736 8.10049 21 12 21L12.0163 20.9999C14.0848 20.9661 16.0962 20.3536 17.8261 19.2403L22.2929 23.7071C22.6834 24.0976 23.3166 24.0976 23.7071 23.7071C24.0976 23.3166 24.0976 22.6834 23.7071 22.2929L18.6562 17.242C18.6496 17.2352 18.643 17.2286 18.6363 17.2221L6.77615 5.36194C6.76961 5.35521 6.763 5.3486 6.75631 5.3421L1.70711 0.292893ZM5.98711 7.40132C4.45032 8.70139 3.14935 10.2582 2.14257 12.0032C2.25165 12.1916 2.39592 12.4311 2.57441 12.7075C3.03543 13.4213 3.71817 14.3706 4.60454 15.3161C6.39395 17.2248 8.89512 18.9969 11.9918 19C13.5373 18.9734 15.0437 18.5524 16.3714 17.7856L14.0498 15.464C13.891 15.5635 13.7251 15.652 13.5531 15.7286C13.0625 15.9472 12.5328 16.0648 11.9957 16.0742C11.4586 16.0837 10.9252 15.9849 10.4271 15.7837C9.92902 15.5826 9.47657 15.2831 9.09674 14.9033C8.71691 14.5235 8.41747 14.071 8.21629 13.5729C8.01511 13.0749 7.91631 12.5414 7.92579 12.0043C7.93527 11.4672 8.05282 10.9375 8.27145 10.4469C8.34806 10.2749 8.43653 10.109 8.53605 9.95027L5.98711 7.40132ZM10.0279 11.4421C9.96372 11.6345 9.92907 11.836 9.92548 12.0396C9.92074 12.3081 9.97014 12.5749 10.0707 12.8239C10.1713 13.0729 10.321 13.2992 10.511 13.4891C10.7009 13.679 10.9271 13.8287 11.1761 13.9293C11.4252 14.0299 11.6919 14.0793 11.9604 14.0745C12.164 14.071 12.3655 14.0363 12.5579 13.9721L10.0279 11.4421ZM10.1279 5.21371C10.7408 5.07025 11.3682 4.99854 11.9977 5.00002L12 5.00002C15.1005 5.00002 17.6045 6.77359 19.3955 8.68397C20.2818 9.62943 20.9646 10.5787 21.4256 11.2926C21.6044 11.5694 21.7488 11.8093 21.858 11.9978C21.3406 12.8982 20.7439 13.7511 20.0748 14.5462C19.7193 14.9688 19.7736 15.5996 20.1962 15.9552C20.6187 16.3108 21.2496 16.2565 21.6052 15.8339C22.479 14.7953 23.2421 13.6684 23.8819 12.4714C24.0348 12.1854 24.0395 11.8429 23.8944 11.5528L23 12C23.5938 11.7031 23.8936 11.5512 23.8936 11.5512L23.8925 11.5489L23.889 11.5421L23.8777 11.5198C23.8681 11.5013 23.8546 11.4753 23.8372 11.4425C23.8025 11.3767 23.752 11.2833 23.686 11.166C23.5542 10.9317 23.3601 10.6015 23.1057 10.2075C22.5979 9.42134 21.8432 8.37062 20.8545 7.31608C18.8959 5.22685 15.9006 3.00084 12.0021 3.00003L12.0012 3.00003C11.2171 2.99828 10.4355 3.08765 9.67209 3.26634C9.13434 3.39222 8.80045 3.93019 8.92632 4.46794C9.05219 5.00569 9.59016 5.33958 10.1279 5.21371ZM22.5 12H22L21.858 11.9978L22.5 12Z"
															fill="#96939E"
														/>
													</g>
													<defs>
														<clipPath id="clip0_960_16511">
															<rect width="24" height="24" fill="white" />
														</clipPath>
													</defs>
												</svg>
											)}
										</button>
									</div>
									<div className="input-button">
										<input
											className="input"
											type={!showConfirmPassword ? 'password' : 'text'}
											required
											placeholder={plan.form_repassword}
											disabled={!isFormAvailable}
											{...repassword}
										/>
										<button
											className="button-icon button-icon--sm"
											onClick={changeConfirmPasswordView}
										>
											{showConfirmPassword ? (
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<g clip-path="url(#clip0_960_16511)">
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L4.56849 5.9827C2.7597 7.53968 1.25036 9.41852 0.118844 11.5272C-0.0347895 11.8135 -0.0397387 12.1566 0.105573 12.4472L1 12C0.105573 12.4472 0.10637 12.4488 0.10637 12.4488L0.107539 12.4512L0.11099 12.458L0.122338 12.4802C0.131875 12.4988 0.145357 12.5247 0.162754 12.5576C0.19754 12.6233 0.248023 12.7168 0.313971 12.834C0.445792 13.0684 0.63985 13.3985 0.894336 13.7926C1.40207 14.5787 2.15683 15.6294 3.14546 16.684C5.10448 18.7736 8.10049 21 12 21L12.0163 20.9999C14.0848 20.9661 16.0962 20.3536 17.8261 19.2403L22.2929 23.7071C22.6834 24.0976 23.3166 24.0976 23.7071 23.7071C24.0976 23.3166 24.0976 22.6834 23.7071 22.2929L18.6562 17.242C18.6496 17.2352 18.643 17.2286 18.6363 17.2221L6.77615 5.36194C6.76961 5.35521 6.763 5.3486 6.75631 5.3421L1.70711 0.292893ZM5.98711 7.40132C4.45032 8.70139 3.14935 10.2582 2.14257 12.0032C2.25165 12.1916 2.39592 12.4311 2.57441 12.7075C3.03543 13.4213 3.71817 14.3706 4.60454 15.3161C6.39395 17.2248 8.89512 18.9969 11.9918 19C13.5373 18.9734 15.0437 18.5524 16.3714 17.7856L14.0498 15.464C13.891 15.5635 13.7251 15.652 13.5531 15.7286C13.0625 15.9472 12.5328 16.0648 11.9957 16.0742C11.4586 16.0837 10.9252 15.9849 10.4271 15.7837C9.92902 15.5826 9.47657 15.2831 9.09674 14.9033C8.71691 14.5235 8.41747 14.071 8.21629 13.5729C8.01511 13.0749 7.91631 12.5414 7.92579 12.0043C7.93527 11.4672 8.05282 10.9375 8.27145 10.4469C8.34806 10.2749 8.43653 10.109 8.53605 9.95027L5.98711 7.40132ZM10.0279 11.4421C9.96372 11.6345 9.92907 11.836 9.92548 12.0396C9.92074 12.3081 9.97014 12.5749 10.0707 12.8239C10.1713 13.0729 10.321 13.2992 10.511 13.4891C10.7009 13.679 10.9271 13.8287 11.1761 13.9293C11.4252 14.0299 11.6919 14.0793 11.9604 14.0745C12.164 14.071 12.3655 14.0363 12.5579 13.9721L10.0279 11.4421ZM10.1279 5.21371C10.7408 5.07025 11.3682 4.99854 11.9977 5.00002L12 5.00002C15.1005 5.00002 17.6045 6.77359 19.3955 8.68397C20.2818 9.62943 20.9646 10.5787 21.4256 11.2926C21.6044 11.5694 21.7488 11.8093 21.858 11.9978C21.3406 12.8982 20.7439 13.7511 20.0748 14.5462C19.7193 14.9688 19.7736 15.5996 20.1962 15.9552C20.6187 16.3108 21.2496 16.2565 21.6052 15.8339C22.479 14.7953 23.2421 13.6684 23.8819 12.4714C24.0348 12.1854 24.0395 11.8429 23.8944 11.5528L23 12C23.5938 11.7031 23.8936 11.5512 23.8936 11.5512L23.8925 11.5489L23.889 11.5421L23.8777 11.5198C23.8681 11.5013 23.8546 11.4753 23.8372 11.4425C23.8025 11.3767 23.752 11.2833 23.686 11.166C23.5542 10.9317 23.3601 10.6015 23.1057 10.2075C22.5979 9.42134 21.8432 8.37062 20.8545 7.31608C18.8959 5.22685 15.9006 3.00084 12.0021 3.00003L12.0012 3.00003C11.2171 2.99828 10.4355 3.08765 9.67209 3.26634C9.13434 3.39222 8.80045 3.93019 8.92632 4.46794C9.05219 5.00569 9.59016 5.33958 10.1279 5.21371ZM22.5 12H22L21.858 11.9978L22.5 12Z"
															fill="#96939E"
														/>
													</g>
													<defs>
														<clipPath id="clip0_960_16511">
															<rect width="24" height="24" fill="white" />
														</clipPath>
													</defs>
												</svg>
											) : (
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M2.57441 12.7075C2.39492 12.4296 2.25003 12.1889 2.14074 12C2.25003 11.8111 2.39492 11.5704 2.57441 11.2925C3.03543 10.5787 3.71817 9.6294 4.60454 8.68394C6.39552 6.77356 8.89951 5 12 5C15.1005 5 17.6045 6.77356 19.3955 8.68394C20.2818 9.6294 20.9646 10.5787 21.4256 11.2925C21.6051 11.5704 21.75 11.8111 21.8593 12C21.75 12.1889 21.6051 12.4296 21.4256 12.7075C20.9646 13.4213 20.2818 14.3706 19.3955 15.3161C17.6045 17.2264 15.1005 19 12 19C8.89951 19 6.39552 17.2264 4.60454 15.3161C3.71817 14.3706 3.03543 13.4213 2.57441 12.7075ZM23 12C23.8944 11.5528 23.8943 11.5524 23.8941 11.5521L23 12ZM23.8941 11.5521C24.0348 11.8336 24.0352 12.1657 23.8944 12.4472L23 12C23.8944 12.4472 23.8938 12.4484 23.8936 12.4488L23.8925 12.4511L23.889 12.458L23.8777 12.4802C23.8681 12.4987 23.8546 12.5247 23.8372 12.5576C23.8025 12.6233 23.752 12.7168 23.686 12.834C23.5542 13.0684 23.3601 13.3985 23.1057 13.7925C22.5979 14.5787 21.8432 15.6294 20.8545 16.6839C18.8955 18.7736 15.8995 21 12 21C8.10049 21 5.10448 18.7736 3.14546 16.6839C2.15683 15.6294 1.40207 14.5787 0.894336 13.7925C0.63985 13.3985 0.445792 13.0684 0.313971 12.834C0.248023 12.7168 0.19754 12.6233 0.162753 12.5576C0.145357 12.5247 0.131875 12.4987 0.122338 12.4802L0.11099 12.458L0.107539 12.4511L0.105573 12.4472L0.999491 12.0003C0.111724 12.4441 0.105434 12.4468 0.105569 12.4472L0.105573 12.4472C-0.0351909 12.1657 -0.0351909 11.8343 0.105573 11.5528L1 12C0.105573 11.5528 0.106186 11.5516 0.10637 11.5512L0.107539 11.5489L0.11099 11.542L0.122338 11.5198C0.131875 11.5013 0.145357 11.4753 0.162753 11.4424C0.19754 11.3767 0.248023 11.2832 0.313971 11.166C0.445792 10.9316 0.63985 10.6015 0.894336 10.2075C1.40207 9.42131 2.15683 8.3706 3.14546 7.31606C5.10448 5.22644 8.10049 3 12 3C15.8995 3 18.8955 5.22644 20.8545 7.31606C21.8432 8.3706 22.5979 9.42131 23.1057 10.2075C23.3601 10.6015 23.5542 10.9316 23.686 11.166C23.752 11.2832 23.8025 11.3767 23.8372 11.4424C23.8546 11.4753 23.8681 11.5013 23.8777 11.5198L23.889 11.542L23.8925 11.5489L23.8941 11.5521ZM10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z"
														fill="#96939E"
													/>
												</svg>
											)}
										</button>
									</div>
									<div className="form__checkbox">
										<div className="checkbox-group">
											<input
												className="checkbox"
												type="checkbox"
												id="checkbox_plan_free"
												required
											/>
											<label htmlFor="checkbox_plan_free">
												<ReactMarkdown
													children={plan.form_tc_description}
													rehypePlugins={[rehypeRaw]}
												/>
											</label>
										</div>
									</div>
									<span className="fs-14 text--gray-dark">
										<ReactMarkdown children={plan.form_tc_info} rehypePlugins={[rehypeRaw]} />
									</span>

									{signUpError && (
										<div className="form__group form__group--vertical m-b-16">
											<p className="text--red">{signUpError}</p>
										</div>
									)}

									<div className="form__button">
										<button type="submit" className="button button--lg" disabled={!isFormAvailable}>
											{plan.button_signup}
										</button>
									</div>
								</div>
							)}
						</form>
					)}

					{showLoginForm && (
						<form onSubmit={handleLoginSubmit}>
							<div className="form__login">
								<input
									className="input"
									type="email"
									required
									placeholder={plan.form_email}
									disabled={!isFormAvailable}
									{...email}
								/>
								<input
									className="input"
									type="password"
									required
									placeholder={plan.form_password}
									disabled={!isFormAvailable}
									{...password}
								/>
								<div className="form__login__password">
									<div className="checkbox-group">
										<input className="checkbox" type="checkbox" id="checkbox_plan_free" required />
										<label htmlFor="checkbox_plan_free">
											<ReactMarkdown children={plan.remember_me} rehypePlugins={[rehypeRaw]} />
										</label>
									</div>
									<a href="https://account.tecalis.com/password/reset">{plan.forgot_password}</a>
								</div>

								{loginError && (
									<div className="form__group form__group--vertical m-b-16">
										<p className="text--red">{loginError}</p>
									</div>
								)}

								<button type="submit" className="button button--lg">
									{plan.button_login}
								</button>
							</div>
						</form>
					)}

					{!showLoginForm && (
						<ReactMarkdown
							children={plan.login_text}
							rehypePlugins={[rehypeRaw]}
							components={loginElements}
						/>
					)}
					{showLoginForm && (
						<ReactMarkdown
							children={plan.signup_text}
							rehypePlugins={[rehypeRaw]}
							components={signupElements}
						/>
					)}
				</div>
			</div>
		</Modal>
	);
};

export default ModalLogin;
